import Stats from '../helpers/Stats';
import General from '../helpers/General';
import { mobile } from '../constants';

export default class CollectionFilters {
  constructor() {
    this.clickToogleFilterButton();
    this.toogleCollapseFilters();
    this.clickClearFitlersButton();
    // this.toogleFilter();
    window.toogleFilters = this.toogleFilters.bind(this);
    window.toogleCollapseFilters = this.toogleCollapseFilters.bind(this);
    // this.filterBestLink();
    this.filterBestSwitcher();

    if (mobile) {
      this.closeFiltersOnMobile();
    }
  }

  clickToogleFilterButton(e) {
    const $_button = document.querySelector('.toogleFilters_button');
    if ($_button) {
      $_button.addEventListener('click', this.toogleFilters, false);

      $_button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          this.toogleFilters();
        }
      });
    }
  }

  clickClearFitlersButton() {
    const $_button = document.querySelector('.js-filters-btn-clear');

    if ($_button) {
      $_button.addEventListener('click', function (e) {
        const event_category = 'filters--new';

        Stats.sendEventDataLayerViaShopify({
          event_category: event_category,
          event_label: 'footerbtn_apply',
        });

        window.location.href = window.location.pathname;
        e.preventDefault();
      });
    }
  }

  toogleFilters() {
    const $_button = document.querySelector('.toogleFilters_button');
    const $_filters = document.querySelector('.toogleFilters_content');
    if ($_button && $_filters) {
      $_filters.classList.toggle('toogleFilters--state-2');
      $_filters.classList.toggle('template-collection__products--filter-none');
      document
        .querySelector('.template-collection__products__list')
        .classList.toggle('template-collection__products--filter-none');
      const text = $_button.querySelector(
        '.toogleFilters_button__label__text'
      ).innerText;
      const new_text = `${text.includes('Show') ? 'Hide' : 'Show'} filters`;
      $_button.querySelector('.toogleFilters_button__label__text').innerText =
        new_text;

      if (mobile) {
        document.querySelector('html').classList.toggle('is-locked');
      }

      if (new_text === 'Show filters') {
        const event_category = 'filters--new';

        Stats.sendEventDataLayerViaShopify({
          event_category: event_category,
          event_label: 'filters-mobile-opened',
        });
      }
    }
  }

  toogleCollapseFilters() {
    const area = document.querySelector('.template-collection__filters'); // the container for the variable content
    if (area) {
      const selector = '.gld-filter__header--toggle'; // any css selector for children
      // gld-filter--options-hide
      const execEvent = (event) => {
        let item = event.target.closest(selector);
        if (
          !item &&
          event.target.classList.contains('gld-filter__header--toggle')
        ) {
          item = event.target;
        }
        if (item) {
          const filter_wrapper = item.closest('.gld-filter');
          const filter_name = filter_wrapper.dataset.filterName || '';

          if (filter_wrapper) {
            const isExpanded = filter_wrapper.classList.toggle('gld-filter--options-hide') === false;
            item.setAttribute('aria-expanded', isExpanded);

            const event_category = 'filters--new';
            Stats.sendEventDataLayerViaShopify({
              event_category: event_category,
              event_label: `toggle_${filter_name.replace(/ /g, '')}`,
            });
          }
        }
      };

      area.addEventListener('click', function (event) {
        execEvent(event);
      });
    }
  }

  closeFiltersOnMobile() {
    const area = document.querySelector(
      '.template-collection__filters--storefront_filtering'
    ); // the container for the variable content
    if (area) {
      const selector = '.gld-filters__header__button--close';
      const selector2 = '.gld-filters__footer__button--apply';
      // gld-filter--options-hide
      const execEvent = (event) => {
        let item =
          event.target.closest(selector) || event.target.closest(selector2);
        const event_category = 'filters--new';

        if (!item && event.target.classList.contains(selector.substring(1))) {
          item = event.target;

          Stats.sendEventDataLayerViaShopify({
            event_category: event_category,
            event_label: 'close_filters_mobile',
          });
        } else if (
          !item &&
          event.target.classList.contains(selector2.substring(1))
        ) {
          item = event.target;

          Stats.sendEventDataLayerViaShopify({
            event_category: event_category,
            event_label: 'footerbtn_apply',
          });
        } else if (!item && event.target === area) {
          item = event.target;
        }
        if (item) {
          this.toogleFilters();
        }
      };
      area.addEventListener('click', function (event) {
        // event.preventDefault();
        execEvent(event);
      });
    }
  }

  filterBestSwitcher() {
    if (this.filterBestSwitcherInitialized) {
      return;
    }

    this.filterBestSwitcherInitialized = true;
    const os = General.getMobileOS();
    const selectorSwitcherItem = '.gld-filters-top__switcher__item'; // any css selector for children
    const execEvent = (event) => {
      let itemSwitcher = event.target.closest(selectorSwitcherItem);
      if (
        !itemSwitcher &&
        event.target.classList.contains(selectorSwitcherItem.substring(1))
      ) {
        itemSwitcher = event.target;
      }

      if (!itemSwitcher) {
        return;
      }

      const area = itemSwitcher.closest('.gld-filters-top__switcher-container'); // the container for the variable content
      const area_switcher = itemSwitcher.closest('.gld-filters-top__switcher'); // the container for the variable content
      const itemValue =
        itemSwitcher?.dataset?.value ||
        itemSwitcher?.innerText?.trim().toLowerCase();
      let switcherUrl = itemSwitcher?.dataset?.url || '';

      if (!area || !area_switcher) {
        return;
      }

      if (
        switcherUrl &&
        !area_switcher.classList.contains(
          'gld-filters-top__switcher--loading'
        ) &&
        itemValue !== area_switcher.dataset.active
      ) {
        event.preventDefault();

        const search = new URLSearchParams(document.location.search);
        search.delete('page');
        search.delete('limit');
        const search_string = search.toString();
        let url = switcherUrl;
        if (search_string.length) {
          url += `${url.includes('?') ? '&' : '?'}${search_string}`;
        }

        const items = area_switcher.children;
        [...items].forEach((element) => {
          element.classList.toggle('gld-filters-top__switcher__item--active');
        });
        // switcher.classList.add('pill--loading')
        // switcher.classList.add('gld-filters-top__switcher--loading')
        area_switcher.dataset.active = itemValue;
        if (os === 'iOS') {
          setTimeout(() => {
            document.location.href = url;
          }, 250);
        } else {
          document.location.href = url;
        }
      }
    };

    document.addEventListener('click', execEvent);
  }
}
